import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CustomerServices = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/customer", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/customer/update/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getCustomerList: async ({ SearchText = "" } = {}) => {
    const params = new URLSearchParams({
      ...(SearchText && { SearchText: SearchText.toString() }),
    });
    const response = await apiService.get(`/customer?${params.toString()}`);
    return response.data;
  },

  getCustomerLists: async () => {
    const response = await apiService.get("/customer/customerfilter");
    return response.data;
  },

  getCustomerDetail: async (customerId) => {
    const response = await apiService.get(
      `/customer/${customerId}/detail-with-orders`
    );
    return response.data;
  },

  getCreditLogs: async (customerId, filters = {}) => {
    try {
      const response = await apiService.get(
        `/creditlogs/customer/${customerId}`,
        { params: filters }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching credit logs:", error);
      throw error;
    }
  },

  getCustomerBooking: async (id) => {
    const response = await apiService.get(`/customers/${id}/bookings`);
    return response.data;
  },

  guestUserList: async () => {
    const response = await apiService.get("/guestusers");
    return response.data;
  },

  getGuestDetail: async (id) => {
    const response = await apiService.get(
      `/customer/guest/withorderdetail/${id}`
    );
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/customer/${id}`);
    return response.data;
  },
};

export default CustomerServices;
